import React, {createRef, useState} from "react"
import styles from "./Home.module.css"
import picOurAdvantages1 from "../../assets/img/pictures/picOurAdvantages1.JPG"
import picOurAdvantages2 from "../../assets/img/pictures/picOurAdvantages2.JPG"
import picOurAdvantages3 from "../../assets/img/pictures/picOurAdvantages3.JPG"
import picOurAdvantages4 from "../../assets/img/pictures/picOurAdvantages4.JPG"
import Logo from '../../assets/img/bigLogo.svg'
import VideoImg from '../../assets/img/pictures/videoImg.png'
import appstoreButton from '../../assets/img/appstoreButton.svg'
import googlePlayButton from '../../assets/img/googlePlayButton.svg'
import telegramButton from '../../assets/img/telegramButton.svg'
import viberButton from '../../assets/img/viberButton.svg'
import Button from '@mui/material/Button'
import PhotoCarousel from "./components/PhotoCarousel"
import Loader from "../subsidiary/Loader/Loader"
import {Link} from "react-router-dom"
import ModalVideo from 'react-modal-video'
import '../../../node_modules/react-modal-video/css/modal-video.min.css';

const Home = ({autologinning}) => {
    // const [isLoaded, setIsLoaded] = useState(false)
    const dowanloadBtn = createRef();

    // const dispatch = useDispatch()
    // const handleClick = () => {
    //     dispatch(createUser())
    // }
    const scrollToBottom = () => {
        dowanloadBtn.current.scrollIntoView({behavior: 'smooth', block: 'center'})

        // window.scrollTo(0, )
        // window.scrollTo({
        //     top: dowanloadBtn.current,
        //     behavior: "smooth"
        // });
    }
    const [isOpen, setOpen] = useState(false);

    return (
        autologinning ? <Loader/> :
            <div>
                <section className={styles.signIn}>
                    {/* <img src={pic1Png} alt="" /> */}
                    <div className={styles.headerBg}>

                    </div>
                    <div className="content-wrapper">
                        <div className={styles.signInWrapper}>
                            <h1 className={styles.title}>
                                ОППО ООО "ЛУКОЙЛ-МЦПБ" <br/>
                                НЕФТЕГАЗСТРОЙПРОФСОЮЗА РОССИИ
                            </h1>
                            <p className={styles.desription}>
                                Войдите или зарегистрируйтесь, чтобы использовать весь функционал сервиса
                            </p>
                            <div className={styles.btnContainer}>
                                <Link to='/login'>
                                    <Button className={styles.signInBtn} variant="contained">
                                        Вход
                                    </Button>
                                </Link>
                                <Button
                                    onClick={scrollToBottom}
                                    className={styles.signUpBtn}
                                    variant="outlined"
                                >
                                    Регистрация
                                </Button>
                            </div>
                        </div>
                    </div>
                </section>
                <section className={styles.ourAdvantages}>
                    <div className="content-wrapper">
                        <div className={styles.ourAdvantagesWrapper}>
                            <h1 className={styles.title}>
                                Чем мне может быть полезно членство в<br/>
                                ОППО:
                            </h1>
                            <div className={styles.cards}>
                                <div className={styles.card}>
                                    <img src={picOurAdvantages2} alt=""/>
                                    <div className={styles.cardTitle}>
                                        Помощь <br/>
                                        работникам
                                    </div>
                                </div>
                                <div className={styles.card}>
                                    <img src={picOurAdvantages3} alt=""/>
                                    <div className={styles.cardTitle}>
                                        Детские <br/>
                                        программы
                                    </div>
                                </div>
                                <div className={styles.card}>
                                    <img src={picOurAdvantages1} alt=""/>
                                    <div className={styles.cardTitle}>
                                        спортивные <br/>
                                        тренировки
                                    </div>
                                </div>
                                <div className={styles.card}>
                                    <img src={picOurAdvantages4} alt=""/>
                                    <div className={styles.cardTitle}>
                                        Деловые <br/>
                                        мероприятия
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className={styles.videoAboutUs}>
                    <div className={styles.videoAboutUsWrapper}>
                        <div className={styles.videoAboutUsContWrapper}>
                            <div className={styles.videoAboutUsBlock}>
                                <div className={styles.videoAboutUsText}>
                                    <h1 className={styles.title}>Видеоролик о ОППО</h1>
                                    <p className={styles.videoAboutUsDescr}>Просмотрите видеоролик о&nbsp;работе ОППО</p>
                                </div>
                                <img src={VideoImg} alt="videoPreview"/>
                                <div className={styles.videoAboutUsButton}>
                                    <ModalVideo channel='custom' isOpen={isOpen} url="/video/videoPPO.mp4"
                                                onClose={() => setOpen(false)}/>
                                    <Button className={styles.videoAboutUsBtn}
                                            onClick={() => setOpen(true)}>Просмотреть</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className={styles.photoSlider}>
                    <div className={styles.photoSliderWrapper}>
                        <div className="content-wrapper">
                            <h1 className={styles.title}>
                                Фотогалерея
                            </h1>
                        </div>
                        <div>
                            <PhotoCarousel/>
                        </div>
                    </div>
                </section>
                <section className={styles.joinUs}>
                    <div className="content-wrapper">
                        <div className={styles.joinUsWrapper}>
                            <h1 className={styles.title}>
                                Вступить в профсоюз
                            </h1>
                            <p ref={dowanloadBtn} className={styles.desription}>
                                Если вы еще не с нами, предлагаем вам вступить в профсоюзную организацию.
                                Для этого скачайте бланк (PDF, DOC), заполните заявление и отправьте на адрес
                                электронной почты <a href="mailto:Ppo-l-mcpb@lukoil.com"
                                                     className="link">Ppo-l-mcpb@lukoil.com</a>
                            </p>
                            <Link to='/documents'>
                                <Button className={styles.dowanloadBtn} variant="contained">Скачать бланк</Button>
                            </Link>
                            <img className={styles.logo} src={Logo}/>
                            <div className={styles.links_container}>
                                <a className={styles.links_element} rel="noreferrer" target='_blank' href="https://apps.apple.com/ru/app/%D0%B2%D0%BC%D0%B5%D1%81%D1%82%D0%B5-%D0%BC%D1%86%D0%BF%D0%B1/id1638676666?l=en">
                                    <img className={styles.link_img} src={appstoreButton} alt=""/>
                                </a>
                                <a className={styles.links_element} rel="noreferrer" target='_blank' href="https://play.google.com/store/apps/details?id=com.company_mcpb.app_vmeste">
                                    <img className={styles.link_img} src={googlePlayButton} alt=""/>
                                </a>
                                <a className={styles.links_element} rel="noreferrer" target='_blank' href="https://t.me/vmeste_mcpb_bot">
                                    <img className={styles.link_img} src={telegramButton} alt=""/>
                                </a>
                                <a className={styles.links_element} rel="noreferrer" target='_blank' href="viber://pa?chatURI=vmeste_mcpb">
                                    <img className={styles.link_img} src={viberButton} alt=""/>
                                </a>
                            </div>
                            <h2 style={{fontSize: '48px', padding: '30px 0'}} className={styles.title}>
                                Есть <br/>
                                вопросы?<br/>
                                Напишите!<br/>
                            </h2>
                            <a style={{fontSize: '24px'}} href="mailto:Ppo-l-mcpb@lukoil.com"
                               className="link">Ppo-l-mcpb@lukoil.com</a>
                            <div style={{marginTop: '40px', marginBottom: '50px'}} className="copy-right">2025 Объединенная 
                                первичная профсоюзная организация
                                ООО “ЛУКОЙЛ - МЦПБ”
                            </div>
                        </div>
                    </div>
                </section>
            </div>

    )
}
export default Home
